var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page message-command-page" }, [
    _c("div", { staticClass: "saas-hero card-saas message-command-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/message" } }, [
              _vm._v(_vm._s(_vm.trans("message.message"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("message.important")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(_vm._s(_vm.trans("message.important"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "card-saas card-saas--flush saas-message-layout message-command-layout",
      },
      [
        _c(
          "div",
          { staticClass: "row g-0" },
          [
            _c("message-sidebar", {
              attrs: { menu: "important", statistics: _vm.statistics },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col saas-message-main" },
              [
                _c("h4", { staticClass: "card-saas__title" }, [
                  _vm._v(_vm._s(_vm.trans("message.important"))),
                ]),
                _vm._v(" "),
                _vm.messages.total
                  ? _c("div", { staticClass: "saas-table-wrap" }, [
                      _c(
                        "table",
                        { staticClass: "table admin-data-table mb-0" },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th"),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("message.sender"))),
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("message.recipient"))),
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.trans("message.subject"))),
                              ]),
                              _vm._v(" "),
                              _c("th"),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.trans("message.received_at"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "table-option" }, [
                                _vm._v(_vm._s(_vm.trans("general.action"))),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.messages.data, function (important) {
                              return _c("tr", { key: important.id }, [
                                _c("td", [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.trans("message.important"),
                                        expression:
                                          "trans('message.important')",
                                      },
                                    ],
                                    staticClass:
                                      "fas fa-star fa-lg starred custom-button",
                                    attrs: {
                                      role: "button",
                                      tabindex: "0",
                                      "aria-label":
                                        _vm.trans("message.important"),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleImportant(important)
                                      },
                                      keydown: [
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                          return _vm.toggleImportant(important)
                                        },
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                          return _vm.toggleImportant(important)
                                        },
                                      ],
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "span",
                                    { staticClass: "message-row__person" },
                                    [_vm._v(_vm._s(important.user_from.email))]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("span", {
                                    staticClass: "message-row__person",
                                    domProps: {
                                      textContent: _vm._s(
                                        important.user_to.email
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("span", {
                                    staticClass: "message-row__subject",
                                    domProps: {
                                      textContent: _vm._s(important.subject),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  important.has_attachment
                                    ? _c("i", {
                                        staticClass: "fas fa-paperclip",
                                      })
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "span",
                                    { staticClass: "message-row__date" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("momentDateTime")(
                                            important.created_at
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "table-option" }, [
                                  _c(
                                    "div",
                                    { staticClass: "btn-group" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: _vm.trans("message.view"),
                                              expression:
                                                "trans('message.view')",
                                            },
                                          ],
                                          staticClass:
                                            "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                                          attrs: {
                                            to: `/message/${important.uuid}`,
                                            "aria-label":
                                              _vm.trans("message.view"),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-arrow-circle-right",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          directives: [
                                            {
                                              name: "confirm",
                                              rawName: "v-confirm",
                                              value: {
                                                ok: _vm.confirmDelete(
                                                  important
                                                ),
                                              },
                                              expression:
                                                "{ok: confirmDelete(important)}",
                                            },
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: _vm.trans(
                                                "message.delete",
                                                {
                                                  type: _vm.trans(
                                                    "message.important"
                                                  ),
                                                }
                                              ),
                                              expression:
                                                "trans('message.delete',{type: trans('message.important')})",
                                            },
                                          ],
                                          key: important.id,
                                          staticClass:
                                            "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                                          attrs: {
                                            type: "button",
                                            "aria-label": _vm.trans(
                                              "message.delete",
                                              {
                                                type: _vm.trans(
                                                  "message.important"
                                                ),
                                              }
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-trash",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass:
                          "admin-list-table-card admin-empty-state message-empty-state",
                        attrs: { role: "status" },
                      },
                      [
                        _c("div", { staticClass: "admin-empty-state__inner" }, [
                          _c(
                            "div",
                            {
                              staticClass: "admin-empty-state__icon-wrap",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_c("admin-icon", { attrs: { name: "star" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "h4",
                            { staticClass: "admin-empty-state__title" },
                            [
                              _vm._v(
                                _vm._s(_vm.trans("general.no_result_found"))
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                _vm._v(" "),
                _c("pagination-record", {
                  attrs: {
                    "page-length": _vm.filterMessageForm.page_length,
                    records: _vm.messages,
                  },
                  on: {
                    "update:pageLength": function ($event) {
                      return _vm.$set(
                        _vm.filterMessageForm,
                        "page_length",
                        $event
                      )
                    },
                    "update:page-length": function ($event) {
                      return _vm.$set(
                        _vm.filterMessageForm,
                        "page_length",
                        $event
                      )
                    },
                    updateRecords: _vm.getMessages,
                  },
                  nativeOn: {
                    change: function ($event) {
                      return _vm.getMessages.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }